import EmployeeProfilePage from "./EmployeeProfilePage";

export default EmployeeProfilePage;
